import { useHistory } from "react-router";

import type { Account } from "~/v2/api/rest/account";
import { Path } from "~/v2/path";
import { FeatureCard } from "./FeatureCard";

export const CryptoCard = ({ account }: { account?: Account }) => {
  const history = useHistory();

  const onClick = () => history.push(Path.ROUTE_PROFILE_CRYPTO_FEES);

  return (
    <FeatureCard
      title="Crypto Fee Rate"
      badge={{ variant: "blue", text: `Level ${account?.crypto_tier ?? 1}` }}
      body={"Volume-based fee rates for trading cryptocurrencies on Alpaca."}
      button={{
        text: "View Fee Rates",
        onClick,
      }}
    />
  );
};
